var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.locker.my_coach.consulting.title"),
          "use-title-as-document-title": false
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "form",
                {
                  staticClass: "forms-sample",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.contactCoach($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "font-weight-bolder",
                          attrs: { for: "title" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.locker.my_coach.consulting.form.title"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactForm.title,
                            expression: "contactForm.title"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.$errors.has("title")
                        },
                        attrs: {
                          type: "text",
                          id: "title",
                          placeholder: _vm.$t(
                            "pages.locker.my_coach.consulting.form.title"
                          )
                        },
                        domProps: { value: _vm.contactForm.title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactForm,
                              "title",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("error", { attrs: { input: "title" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "font-weight-bolder",
                          attrs: { for: "message" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.locker.my_coach.consulting.form.message"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contactForm.message,
                            expression: "contactForm.message"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.$errors.has("message")
                        },
                        attrs: {
                          type: "textarea",
                          rows: "8",
                          id: "message",
                          placeholder: _vm.$t(
                            "pages.locker.my_coach.consulting.form.message"
                          )
                        },
                        domProps: { value: _vm.contactForm.message },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contactForm,
                              "message",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("error", { attrs: { input: "message" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("button", { staticClass: "btn btn-outline-dark" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$t("pages.locker.my_coach.consulting.form.send")
                        ) +
                        "\n                        "
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }